module.exports = __webpack_public_path__ + "fonts/Averta-Regular.a25878c.eot";